import CopyShareLinkIcon from "@apps/wishlist/components/WishlistSocialShare/icons/CopyShareLinkIcon.svelte";
import EmailShareIcon from "@apps/wishlist/components/WishlistSocialShare/icons/EmailShareIcon.svelte";
import FacebookShareIcon from "@apps/wishlist/components/WishlistSocialShare/icons/FacebookShareIcon.svelte";
import PinterestShareIcon from "@apps/wishlist/components/WishlistSocialShare/icons/PinterestShareIcon.svelte";
import TwitterShareIcon from "@apps/wishlist/components/WishlistSocialShare/icons/TwitterShareIcon.svelte";
import WhatsAppShareIcon from "@apps/wishlist/components/WishlistSocialShare/icons/WhatsAppShareIcon.svelte";
import { ComponentType } from "svelte";

import BookmarkFilledIcon from "@components/WishlistIcon/customIcons/BookmarkFilledIcon.svelte";
import BookmarkOutlinedIcon from "@components/WishlistIcon/customIcons/BookmarkOutlinedIcon.svelte";
import DefaultHeartFilledIcon from "@components/WishlistIcon/customIcons/DefaultHeartFilledIcon.svelte";
import DefaultHeartOutlinedIcon from "@components/WishlistIcon/customIcons/DefaultHeartOutlinedIcon.svelte";
import DocumentFilledIcon from "@components/WishlistIcon/customIcons/DocumentFilledIcon.svelte";
import DocumentOutlinedIcon from "@components/WishlistIcon/customIcons/DocumentOutlinedIcon.svelte";
import GiftFilledIcon from "@components/WishlistIcon/customIcons/GiftFilledIcon.svelte";
import GiftOutlinedIcon from "@components/WishlistIcon/customIcons/GiftOutlinedIcon.svelte";
import HeartFilledIcon from "@components/WishlistIcon/customIcons/HeartFilledIcon.svelte";
import HeartOutlinedIcon from "@components/WishlistIcon/customIcons/HeartOutlinedIcon.svelte";
import LikeFilledIcon from "@components/WishlistIcon/customIcons/LikeFilledIcon.svelte";
import LikeOutlinedIcon from "@components/WishlistIcon/customIcons/LikeOutlinedIcon.svelte";
import RewardFilledIcon from "@components/WishlistIcon/customIcons/RewardFilledIcon.svelte";
import RewardOutlinedIcon from "@components/WishlistIcon/customIcons/RewardOutlinedIcon.svelte";
import SparkleFilledIcon from "@components/WishlistIcon/customIcons/SparkleFilledIcon.svelte";
import SparkleOutlinedIcon from "@components/WishlistIcon/customIcons/SparkleOutlinedIcon.svelte";
import StarFilledIcon from "@components/WishlistIcon/customIcons/StarFilledIcon.svelte";
import StarOutlinedIcon from "@components/WishlistIcon/customIcons/StarOutlinedIcon.svelte";

export const WISHLIST_EMAIL_PARAM_TOKEN = "saveWishlistsToken";
export const WISHLIST_PAGE_PATHNAME = "/pages/wishlist";
export const DESIGN_MODE_SHARE_TOKEN = "designModeShareToken";
export const GUEST_EMAIL_STORAGE_KEY = "gwGuestEmail";

export enum SAVE_WISHLIST_MODAL_ACTION_TYPES {
    saveWishlists = "saveWishlists",
    addItem = "addItem",
}

export enum WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES {
    copyShareLink = "copyShareLink",
    email = "email",
    facebook = "facebook",
    twitter = "twitter",
    pinterest = "pinterest",
    whatsapp = "whatsapp",
}
export const WISHLIST_SOCIAL_SHARE_ICONS: Record<
    WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES,
    ComponentType
> = {
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.copyShareLink]: CopyShareLinkIcon,
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.email]: EmailShareIcon,
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.facebook]: FacebookShareIcon,
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.twitter]: TwitterShareIcon,
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.pinterest]: PinterestShareIcon,
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.whatsapp]: WhatsAppShareIcon,
};

export const WISHLIST_SOCIAL_SHARE_SETTINGS = {
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.copyShareLink]: {
        className: "gw-wl-social-share__copy-link-btn",
    },
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.email]: {
        className: "gw-wl-social-share__email-btn",
    },
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.facebook]: {
        className: "gw-wl-social-share__facebook-btn",
    },
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.twitter]: {
        className: "gw-wl-social-share__twitter-btn",
    },
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.pinterest]: {
        className: "gw-wl-social-share__pinterest-btn",
    },
    [WISHLIST_SOCIAL_SHARE_CHANNEL_NAMES.whatsapp]: {
        className: "gw-wl-social-share__whatsapp-btn",
    },
};

export enum WISHLIST_ICON_TYPES {
    default = "default",
    bookmark = "bookmark",
    document = "document",
    gift = "gift",
    heart = "heart",
    like = "like",
    reward = "reward",
    sparkle = "sparkle",
    star = "star",
}

export const WISHLIST_ICON_TYPES_LIST = Object.values(WISHLIST_ICON_TYPES);

export const WISHLIST_ICONS: Record<
    WISHLIST_ICON_TYPES,
    {
        filled: ComponentType;
        outlined: ComponentType;
    }
> = {
    [WISHLIST_ICON_TYPES.default]: {
        filled: DefaultHeartFilledIcon,
        outlined: DefaultHeartOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.bookmark]: {
        filled: BookmarkFilledIcon,
        outlined: BookmarkOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.document]: {
        filled: DocumentFilledIcon,
        outlined: DocumentOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.gift]: {
        filled: GiftFilledIcon,
        outlined: GiftOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.heart]: {
        filled: HeartFilledIcon,
        outlined: HeartOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.like]: {
        filled: LikeFilledIcon,
        outlined: LikeOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.reward]: {
        filled: RewardFilledIcon,
        outlined: RewardOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.sparkle]: {
        filled: SparkleFilledIcon,
        outlined: SparkleOutlinedIcon,
    },
    [WISHLIST_ICON_TYPES.star]: {
        filled: StarFilledIcon,
        outlined: StarOutlinedIcon,
    },
};
